import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTable, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { SolicitacaoService } from 'src/app/core/apis/solicitacao/solicitacao.service';
import { Titular } from 'src/app/core/model/titular';
import { ErrorHandlerService } from 'src/app/core/service/error-handler.service';
import { OrdemBuilderService } from 'src/app/core/service/ordem-builder.service';
import { AcaoButtonsComponent } from "src/app/shared/components/acao-buttons/acao-buttons.component";
import { ListaTitularesComponent } from 'src/app/shared/components/lista-titulares/lista-titulares.component';
import { NroProcessoInputComponent } from 'src/app/shared/components/nro-processo-input/nro-processo-input.component';
import { SlaSelectorComponent } from "src/app/shared/components/sla-selector/sla-selector.component";
import { Globals } from 'src/app/shared/helpers/globals';

@Component({
    selector: 'app-consulta-historico',
    templateUrl: './consulta-historico.component.html',
    styleUrls: ['./consulta-historico.component.css'],
    providers: [provideNgxMask()],
    imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatOptionModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    FormsModule,
    NroProcessoInputComponent,
    SlaSelectorComponent,
    AcaoButtonsComponent,
    ListaTitularesComponent
]
})
export class ConsultaHistoricoComponent {

  @Input() tokenIam: string;

  form: UntypedFormGroup;

  @ViewChild(MatTable) table: MatTable<Titular>;
  displayedColumns: string[] = ["nome", "nroDocumento", "action"];

  @ViewChild(NroProcessoInputComponent) nroProcessoInput!: NroProcessoInputComponent;
  @ViewChild(ListaTitularesComponent) listaTitularesComponent!: ListaTitularesComponent;

  titulares: Titular[];

  constructor(
    private globals: Globals,
    private solicitacaoService: SolicitacaoService,
    private ordemBuilderService: OrdemBuilderService,
    private errorHandler: ErrorHandlerService,
    private router: Router,
    fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      nroProcesso: [""],
      nroSla: ["120", Validators.required],
      anosHistorico: ["5", Validators.required]
    });

    this.titulares = [];
  }

  public isPessoaFisica(nroDocumento: string) {
    return nroDocumento.length == 11;
  }

  public consultarHistorico() {
    if(!this.isFormValid()){
      this.touchForm();
      return;
    }
    this.globals.addToLoading("cadastrar-ordem");

    const ordem = this.ordemBuilderService.buildHistorico(this.nroProcesso.value, this.titulares, this.form.value);
    this.solicitacaoService.saveSolicitacao(ordem, this.tokenIam).subscribe({
      next: (response) => {
        this.globals.subtractFromLoading();
        this.globals.showSnackBar("Consulta de histórico enviada com sucesso!", ["snackbar-success"]);
        this.router.navigate(["/ordem"]);
      },
      error: (error) => {
        this.globals.subtractFromLoading();
        this.errorHandler.handle(error);
      }
    });
  }

  private touchForm() {
    this.form.markAllAsTouched();
    this.nroProcessoInput.control.markAsTouched();
    if(this.isTitularesEmpty()){
      this.listaTitularesComponent.nome.setErrors({titularesEmpty: true})
      this.listaTitularesComponent.documento.setErrors({titularesEmpty: true})
      this.listaTitularesComponent.form.markAllAsTouched();
    }
  }

  public isFormValid(): boolean{
    return this.form.valid && !this.isTitularesEmpty();
  }

  private isTitularesEmpty(): boolean{
    return this.titulares.length == 0;
  }

  public onTitularesChange(titulares: Titular[]) {
    this.titulares = titulares;
  }

  get nroProcesso() {
    return this.form.get("nroProcesso");
  }

  get nroSla() {
    return this.form.get("nroSla");
  }

  get anosHistorico() {
    return this.form.get("anosHistorico");
  }
}
